import styled, { css, SimpleInterpolation } from 'styled-components';

import Media from '../../../assets/styles/media';

export const DropdownCtn = styled.div`
  display: flex;
  align-items: center;

  > span {
    font-size: 16px;
    padding-right: 10px;

    ${Media.Below.desktopLarge`
      font-size: 14px;
    `}
  }

  > div {
    width: 170px;
  }

  ${Media.Below.desktopLarge`
    justify-content: flex-end;
  `}

  ${Media.Below.tablet`
    justify-content: flex-start;
  `}
`;

export const DropdownPosCtn = styled.div`
  display: flex;
  justify-content: flex-end;
  width: 100%;
  padding-bottom: 20px;

  ${Media.Below.desktopLarge`
    padding-bottom: 10px;
  `}
`;

interface JobDetailsCtn {
  active?: boolean;
  height?: number;
}

export const JobDetailsCtn = styled.div<JobDetailsCtn>`
  flex: 0 0 0%;
  padding: 55px 0 55px 0;
  background-color: white;
  position: sticky;
  top: 10px;
  height: 1000px;
  overflow-y: scroll;
  z-index: 90;
  transition: all 0.5s ease-in-out;

  ${Media.Below.desktopLarge`
    display: none;
  `}

  ${(props): SimpleInterpolation =>
    props.active &&
    css`
      flex: 1 0 47%;
      padding: 55px 140px 55px 70px;
    `}
    
    ${(props): SimpleInterpolation => `
    height: ${props.height}px
    `}
`;

export const JobsListCtn = styled.div`
  flex: 1 1 47%;
  margin-top: 50px;
  padding: 0 4vw;

  ${Media.Below.desktopLarge`
    margin-top: 10px;
  `}
`;

export const JobsTopCtn = styled.div`
  display: flex;
  flex-direction: column;
`;

export const PageCtn = styled.div`
  display: flex;

  ${Media.Below.desktopLarge`
    flex-direction: column;
  `}
`;

export const PageHeaderText = styled.span`
  font-size: 40px;
  font-weight: bold;

  ${Media.Below.desktop`
    font-size: 25px;
  `}

  ${Media.Below.mobileLarge`
    text-align: center;
  `}
`;

export const SearchBox = styled.input`
  padding: 5px 0;
  border-bottom: grey 1px solid;
  background: transparent;
  padding: 10px 0;
  max-width: 400px;

  ${Media.Below.desktop`
    font-size: 15px;
    max-width: unset;
  `}
`;

export const SearchTabCtn = styled.div`
  flex: 0 1 6%;
`;

export const ExportCtn = styled.div`
  width: 15%;
  margin-right: 20px;
  
  > span {
    width: 100%;
  }
  
  ${Media.Below.desktop`
    width: 30%;
  `}
  
  ${Media.Below.tablet`
    width: 90%;
  `}
`;
